import {useAppSelector} from '@/redux-store/store';
import {useMemo} from 'react';
import {Grid} from '@mui/material';
import ModuleCard from './module-card';
import {Module} from '@/types/module';

const ModulesView = () => {
  const myModules = useAppSelector((state) => state.modules.modules);

  const availableModules = useMemo(() => {
    const modulesKeys = myModules.map((module) => module.key);
    return modulesKeys;
  }, [myModules]);

  const sortedGroups = useMemo(() => {
    const groupedModules = myModules.reduce(
      (acc: Record<number, Module[]>, cur: Module) => {
        (acc[cur.index] = acc[cur.index] || []).push(cur);
        return acc;
      },
      {} as Record<number, Module[]>
    );

    return Object.values(groupedModules).sort(
      (a, b) => a[0].index - b[0].index
    );
  }, [myModules]);

  if (myModules.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        rowSpacing={5}
        columnSpacing={{xs: 2, md: 4}}
        sx={{marginTop: 3, marginBottom: 5}}
        maxWidth={'lg'}
      >
        {sortedGroups.map((group, index) => {
          const isOdd = group.length % 2 !== 0;

          return (
            <Grid
              item
              xs={12}
              key={index}
              sx={{
                marginBottom: 2
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                rowSpacing={5}
                columnSpacing={{xs: 2, md: 4}}
              >
                {group.map((module, idx) => {
                  const aloneInRow = isOdd && idx === group.length - 1;
                  return (
                    <Grid
                      item
                      xs={aloneInRow ? 12 : 6}
                      sm={aloneInRow ? 6 : 6}
                      key={module.key}
                    >
                      <ModuleCard
                        module={module}
                        availableModules={availableModules}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default ModulesView;
